import { FC, ReactNode, useRef } from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import {
  ViewTabs,
  ViewTitle,
  ViewTitleContainer,
  ViewTooltip,
  ViewTooltipIcon
} from './styles'

interface TemplateViewProps {
  title?: string | null
  tooltip?: ReactNode
}

const TemplateView: FC<TemplateViewProps> = ({
  children,
  title = 'Tabs',
  tooltip
}) => {
  const refTooltip = useRef(null)

  return (
    <ViewTabs className='ui-view-with-tabs'>
      <ViewTitleContainer className='mt-4 mb-4 mt-lg-5'>
        <ViewTitle data-testid='template-view-title'>{title}</ViewTitle>
        {tooltip && (
          <ViewTooltip className='ui-vwt-tooltip'>
            <OverlayTrigger
              placement='bottom'
              overlay={
                <Popover id='ui-vwt-tooltip-popover'>
                  <Popover.Content style={{ padding: '8px' }}>
                    {tooltip}
                  </Popover.Content>
                </Popover>
              }
            >
              <ViewTooltipIcon
                className='mdi mdi-help-circle-outline'
                ref={refTooltip}
              />
            </OverlayTrigger>
          </ViewTooltip>
        )}
      </ViewTitleContainer>
      {children}
    </ViewTabs>
  )
}

export default TemplateView
